import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem } from '@mui/material';
// routes
import Avatar from '@mui/material/Avatar';
import { useDispatch, useSelector } from 'react-redux';
import { PERMISSIONS } from '../../../utils/constant';
import { authUserLogout } from '../../../store/slices/authSlice';
import { getInitials } from '../../../utils/helper';
import { PATH_AUTH, PATH_DASHBOARD } from '../../../routes/paths';
// auth
// components
import { CustomAvatar } from '../../../components/custom-avatar';
import { useSnackbar } from '../../../components/snackbar';
import MenuPopover from '../../../components/menu-popover';
import { IconButtonAnimate } from '../../../components/animate';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();
  const { permissions } = useSelector((state) => ({
    permissions: state.auth.permissions,
  }));

  const OPTIONS = [
    {
      label: 'Home',
      linkTo: '/',
    },
    {
      label: 'Profile',
      linkTo: PATH_DASHBOARD.profile,
      hidden: !permissions[PERMISSIONS.PROFILE_VIEW],
    },
  ];

  const dispatch = useDispatch();

  const { user } = useSelector((state) => ({
    user: state.auth.user,
  }));

  const defaultAvatar = getInitials(user);
  const { enqueueSnackbar } = useSnackbar();

  const [openPopover, setOpenPopover] = useState(null);

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleLogout = async () => {
    dispatch(authUserLogout({}))
      .unwrap()
      .then((res) => {
        enqueueSnackbar(res.message);
        navigate(PATH_AUTH.login, { replace: true });
        handleClosePopover();
      })
      .catch((error) => enqueueSnackbar('Unable to logout!', { variant: 'error' }));
  };

  const handleClickItem = (path) => {
    handleClosePopover();
    navigate(path);
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          p: 0,
          ...(openPopover && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        {user?.photoURL ? (
          <CustomAvatar src={user?.photoURL} alt={user?.first_name} name={user?.first_name} />
        ) : (
          <Avatar sx={{ width: 45, height: 45 }}>{defaultAvatar}</Avatar>
        )}
      </IconButtonAnimate>

      <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 200, p: 0 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.first_name} {user?.last_name}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {OPTIONS.filter((item) => !item.hidden).map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </MenuPopover>
    </>
  );
}
